module.exports = __webpack_public_path__ + "media/images/roku/TV1-377ae6e2cc70babb29384f8f494e3da5.png";